import { render } from "./ModalCreateOrUpdateFracionados.vue?vue&type=template&id=7ed355f2&ts=true"
import script from "./ModalCreateOrUpdateFracionados.vue?vue&type=script&lang=ts"
export * from "./ModalCreateOrUpdateFracionados.vue?vue&type=script&lang=ts"

import "./ModalCreateOrUpdateFracionados.vue?vue&type=style&index=0&id=7ed355f2&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__